import { getIdsFromStringifiedIds, getStringifiedItemIds, placeSeparatorAtEnds } from "./stringifiedItemIdsHelpers.js";
import { getFirstVisibleAtTopItem, getVisibleAtTopItemsOnly } from "./visibleItemsHelpers.js";
function maintainScrollOnEndsUpdate(params) {
  const {
    newItems,
    actualScroll,
    scrollHeight,
    oldVisibleItems,
    oldStringifiedIds,
    endsUpdateOptions: { addedAtTop = false, removedFromTop = false, addedAtBottom = false, removedFromBottom = false }
  } = params;
  if (!oldStringifiedIds || !newItems.length) {
    return { success: false };
  }
  if (!addedAtTop && !removedFromTop && !addedAtBottom && !removedFromBottom) {
    return { success: false };
  }
  const oldItemIds = getIdsFromStringifiedIds(oldStringifiedIds);
  let firstCommonItemId;
  for (let i = 0, n = oldItemIds.length; i < n && firstCommonItemId === void 0; i++) {
    const firstCommonItem = newItems.find(({ item }) => item.id.toString() === oldItemIds[i]);
    if (firstCommonItem) {
      firstCommonItemId = firstCommonItem.item.id.toString();
    }
  }
  if (firstCommonItemId === void 0) {
    return {
      success: false
    };
  }
  const newStringifiedIds = getStringifiedItemIds(newItems);
  let oldItemsBeforeCommonItemId = "";
  let newItemsBeforeCommonItemId = "";
  let oldsItemAfterCommonItemId = "";
  let newItemsAfterCommonItemId = "";
  const itemsHaveBeen = {
    removedFromTop: false,
    addedAtTop: false,
    removedFromBottom: false,
    addedAtBottom: false
  };
  if (!oldStringifiedIds || newStringifiedIds === oldStringifiedIds) {
    const firstCommonItem = getFirstVisibleAtTopItem({
      items: oldVisibleItems,
      scrollY: actualScroll,
      scrollHeight
    });
    if (firstCommonItem) {
      return {
        success: true,
        itemToMaintainVisible: firstCommonItem
      };
    }
    return {
      success: false
    };
  }
  firstCommonItemId = placeSeparatorAtEnds(firstCommonItemId);
  if (!oldStringifiedIds.startsWith(firstCommonItemId)) {
    oldItemsBeforeCommonItemId = placeSeparatorAtEnds(oldStringifiedIds.split(firstCommonItemId)[0]);
  }
  if (!oldStringifiedIds.endsWith(firstCommonItemId)) {
    oldsItemAfterCommonItemId = placeSeparatorAtEnds(oldStringifiedIds.split(firstCommonItemId)[1]);
  }
  if (!newStringifiedIds.startsWith(firstCommonItemId)) {
    newItemsBeforeCommonItemId = placeSeparatorAtEnds(newStringifiedIds.split(firstCommonItemId)[0]);
  }
  if (!newStringifiedIds.endsWith(firstCommonItemId)) {
    newItemsAfterCommonItemId = placeSeparatorAtEnds(newStringifiedIds.split(firstCommonItemId)[1]);
  }
  if (oldItemsBeforeCommonItemId !== newItemsBeforeCommonItemId) {
    itemsHaveBeen.removedFromTop = oldItemsBeforeCommonItemId.endsWith(newItemsBeforeCommonItemId);
    itemsHaveBeen.addedAtTop = newItemsBeforeCommonItemId.endsWith(oldItemsBeforeCommonItemId);
  }
  if (oldsItemAfterCommonItemId !== newItemsAfterCommonItemId) {
    itemsHaveBeen.addedAtBottom = newItemsAfterCommonItemId.startsWith(oldsItemAfterCommonItemId);
    itemsHaveBeen.removedFromBottom = oldsItemAfterCommonItemId.startsWith(newItemsAfterCommonItemId);
  }
  const success = addedAtTop && itemsHaveBeen.addedAtTop || removedFromTop && itemsHaveBeen.removedFromTop || addedAtBottom && itemsHaveBeen.addedAtBottom || removedFromBottom && itemsHaveBeen.removedFromBottom;
  if (success) {
    const oldUserVisibleItems = getVisibleAtTopItemsOnly({
      items: oldVisibleItems,
      scrollY: actualScroll,
      scrollHeight
    });
    let firstUserVisibleItem;
    for (let i = 0, n = oldUserVisibleItems.length; i < n && !firstUserVisibleItem; i++) {
      const item = oldUserVisibleItems[i];
      if (newStringifiedIds.includes(placeSeparatorAtEnds(item.item.id.toString()))) {
        firstUserVisibleItem = item;
      }
    }
    let itemToMaintainVisible;
    if (!firstUserVisibleItem) {
      itemToMaintainVisible = itemsHaveBeen.removedFromTop && removedFromTop ? newItems[0] : itemsHaveBeen.removedFromBottom && removedFromBottom ? itemToMaintainVisible = newItems[newItems.length - 1] : void 0;
    } else if (firstUserVisibleItem) {
      itemToMaintainVisible = firstUserVisibleItem;
    }
    if (itemToMaintainVisible) {
      return {
        success: true,
        itemToMaintainVisible
      };
    }
  }
  return {
    success: false
  };
}
export {
  maintainScrollOnEndsUpdate
};
//# sourceMappingURL=maintainScrollOnEndsUpdate.js.map
